import { useContext } from "react";
import NavbarContext from "../contexts/navbar-context";

export const useNavbar = () => useContext(NavbarContext);
